'use client';

import React from 'react';
import styled from '@benzinga/themetron';
import { Icon } from '../Icon';
import { faStar } from '@fortawesome/pro-solid-svg-icons/faStar';

interface StarProps {
  active: number;
  index: number;
  readOnly: boolean;
  size?: number;
}

export const Star: React.FC<StarProps> = ({ active, index, readOnly, size = 18 }) => {
  const showEmptyIcon = active === -1 || active < index + 1;
  const isActiveRating = active !== 1;
  const isRatingWithPrecision = active % 1 !== 0;
  const isRatingEqualToIndex = Math.ceil(active) === index + 1;
  const showRatingWithPrecision = isActiveRating && isRatingWithPrecision && isRatingEqualToIndex;

  return (
    <StyledStar
      $size={size}
      className={`star ${isActiveRating ? 'active' : 'inactive'}`}
      key={index}
      role={readOnly ? undefined : 'button'}
    >
      <div
        style={{
          overflow: 'hidden',
          position: 'absolute',
          width: showRatingWithPrecision ? `${(active % 1) * 100}%` : '0%',
        }}
      >
        <Icon icon={faStar} />
      </div>
      <div
        style={{
          color: showEmptyIcon ? '#CEDDF2' : 'inherit',
        }}
      >
        <Icon icon={faStar} />
      </div>
    </StyledStar>
  );
};

const StyledStar = styled.div<{ $size?: number }>`
  &.star {
    color: #3f83f8;
    position: relative;
    font-size: ${({ $size }) => $size || 18}px;
  }
`;

export default Star;
